<div class="schedule-page">
    <div class="schedule-page__scheduler">
        <span class="text-heading-xs" style="margin-left: auto; margin-right: auto">Scheduler</span>
        <div style="margin-top: var(--spacing-s); margin-left: auto; margin-right: auto">
            <label for="start-date" class="text-body-xxs">Start Date: </label>
            <input
                type="date"
                class="j-text-field"
                style="width: 220px; cursor: pointer; margin-right: var(--spacing-m)"
                id="start-date"
                (change)="setDate($event, 'start')"
                [ngModel]="startDate"
                [min]="minStartDate"
                [max]="maxStartDate"
            />

            <label for="end-date" class="text-body-xxs">End Date: </label>
            <input
                type="date"
                class="j-text-field"
                style="width: 220px; cursor: pointer"
                id="end-date"
                (change)="setDate($event, 'end')"
                [ngModel]="endDate"
                [min]="minEndDate"
            />
        </div>
        <div class="schedule-page__time">
            <label for="start-time" class="text-body-xxs">Start Time: </label>
            <div style="position: relative; margin-right: var(--spacing-m)">
                <input
                    type="time"
                    class="j-text-field"
                    style="width: 220px; cursor: pointer"
                    id="start-time"
                    (change)="setTime($event, 'start')"
                    [ngModel]="startTime"
                    step="1"
                />
                <app-icon
                    style="position: absolute; right: 0; top: 5px"
                    ic="IcClose"
                    size="s"
                    color="var(--color-primary-60)"
                    (click)="clearTime('start')"
                ></app-icon>
            </div>

            <label for="end-time" class="text-body-xxs">End Time: </label>
            <div style="position: relative">
                <input
                    type="time"
                    class="j-text-field"
                    style="width: 220px; cursor: pointer"
                    id="end-time"
                    (change)="setTime($event, 'end')"
                    [ngModel]="endTime"
                    step="1"
                />
                <app-icon
                    style="position: absolute; right: 0; top: 5px"
                    ic="IcClose"
                    size="s"
                    color="var(--color-primary-60)"
                    (click)="clearTime('end')"
                ></app-icon>
            </div>
        </div>
        <!-- <div class="schedule-page__day-btn-holder">
            <ng-container *ngFor="let day of daysData; let i = index">
                <button
                    class="schedule-page__day-btn text-button"
                    [ngClass]="day.selected ? 'schedule-page__day-btn--selected' : ''"
                    (click)="selectDay(i)"
                >
                    {{ day.day }}
                </button>
            </ng-container>
        </div> -->
    </div>
    <div>
        <div style="text-align: right">
            <button
                class="j-button j-button--type-2"
                (click)="addSchedule()"
                style="text-align: right; margin-top: var(--spacing-s)"
            >
                <span class="text-button">Add</span>
            </button>
        </div>
        <div style="margin-top: 10px">
            <app-table tableName="MULTISCHEDULE_LIST" [tableData]=""></app-table>
        </div>

        <div *ngFor="let schedule of scheduleItemsArray; let index = index" class="schedule-row">
            <div class="schedule-cell" style="margin-left: 20px">
                <span *ngIf="schedule === '24x7'; else startDate">{{ schedule === '24x7' ? '24x7' : '' }}</span>
                <ng-template #startDate>
                    <span *ngIf="schedule.startdate">{{ schedule.startdate }}</span>
                </ng-template>
            </div>
            <div class="schedule-cell" style="margin-left: 30px">
                <span *ngIf="schedule !== '24x7' && schedule.starttime">{{ schedule.starttime }}</span>
            </div>
            <div class="schedule-cell" style="margin-left: 30px">
                <span *ngIf="schedule !== '24x7' && schedule.enddate">{{ schedule.enddate }}</span>
            </div>
            <div class="schedule-cell" style="margin-left: 40px">
                <span *ngIf="schedule !== '24x7' && schedule.endtime">{{ schedule.endtime }}</span>
            </div>

            <div class="schedule-cell">
                <app-icon
                    ic="IcTrash"
                    size="s"
                    color="var(--color-primary-50)"
                    (click)="deleteBtnAction(index)"
                ></app-icon>
            </div>
        </div>
    </div>
</div>
<div style="position: relative; top: var(--spacing-xs)">
    <button class="j-button j-button--type-2" (click)="submitItemsSchedule()" style="text-align: right">
        <span class="text-button">Submit</span>
    </button>
</div>
